<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>dashboard_customize</mat-icon>
        <div>Anuidades GN1</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">

        <!--
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">
      -->

        <!--   
        <a mat-button (click)='file.click()'>
          <mat-icon color='primary'>upload</mat-icon>
        </a>
        <input id='selectedFile' style="display: none;" #file type="file" (change)="readCSVFile($event)" />


        <a mat-button (click)="changeOrders()" style='width:60px;'>
          changeOrders
        </a>
      -->
      </div>

    </mat-toolbar>

  </mat-card>

  <mat-card>



  </mat-card>

</div>